import * as s from "react";
import t from "../lib/IconBase.es.js";
import n from "../defs/ListMagnifyingGlass.es.js";
const a = s.forwardRef((i, o) => /* @__PURE__ */ s.createElement(t, { ref: o, ...i, weights: n }));
a.displayName = "ListMagnifyingGlassIcon";
const f = a;
export {
  f as ListMagnifyingGlass,
  a as ListMagnifyingGlassIcon
};
